import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getYouTubeId(video_url: string | null | undefined): string | null {
  if (!video_url || typeof video_url !== 'string') return null;

  try {
    const url = new URL(video_url);
    const searchParams = url.searchParams;
    const videoId: string | null = searchParams.get('v');

    if (!videoId) {
      const [, idFromShorts] = video_url.split('/shorts/');
      return idFromShorts ?? null;
    }

    return videoId;
  } catch {
    return null;
  }
}

export function snakeToCamlel(str: string): string {
  if (!str) return str;

  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}
